import { createApp } from 'vue'
import * as Sentry from '@sentry/vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import i18n from './locales'
import './assets/styles/main.css'
import { clearClientCachesAndServiceWorkers } from '@/utils/clear-client-cache'
import { initFlutterBridge } from '@/utils/flutter-bridge'

/* 더블탭 줌: viewport에 user-scalable=no가 있으나, 데스크톱·일부 WebView 대비 */
document.addEventListener('dblclick', (event) => {
  event.preventDefault()
}, { passive: false })

function bootstrapApp() {
  const app = createApp(App)

  if (import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
      app,
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.VITE_APP_ENV || 'local',
      integrations: [
        Sentry.browserTracingIntegration({ router })
      ],
      tracesSampleRate: import.meta.env.VITE_APP_ENV === 'production' ? 0.2 : 1.0
    })
  }

  app.use(createPinia())
  app.use(router)
  app.use(i18n)
  app.mount('#app')

  // 앱(WebView) 안에서만 의미가 있다. 브라우저에서는 FlutterChannel 이 없어
  // 보내는 쪽이 조용히 넘어가고 받는 이벤트도 오지 않는다. 분기할 필요가 없다.
  initFlutterBridge(router)
}

clearClientCachesAndServiceWorkers().finally(() => {
  bootstrapApp()
})
